import interceptor from '../restServiceInterceptor';
import { Option, TableData } from '../models/table-models';
import { Log, LogFilter, toLogFilter } from '../models/log-models';
import { TableRequestParams } from './data-hooks';

export const useGetAllLogs = (props: TableRequestParams): Promise<TableData<Log[]>> => {
    let loggerFilter: LogFilter = { operations: [] };
    if (props.filter) {
        loggerFilter = toLogFilter(props.filter);
    }
    return interceptor.post(
        `/logger-service/chronologies/users`,
        { filter: loggerFilter, pager: props.pagination },
        {
            params: {},
        }
    );
};
export const useGetLogOperations = (): Promise<Option[]> => {
    return interceptor.get(`/logger-service/chronologies/users/operations`, {});
};
